<template>
    <mySubPage>
        <div slot="header">
            <myNav>信誉值流动历史[{{vendor_cname}}]</myNav>
        </div>
        <div class="relative fillh">
            <myVendorCrSn :vendor_id="vendor_id" v-if="vendor_id != ''"></myVendorCrSn>
        </div>
    </mySubPage>
</template>

<script>
    import myVendorCrSn from "../../../components/myVendorCrSn"
    export default {
        components:{
            myVendorCrSn
        },
        data:function(){
            return{
                vendor_id:'',
                vendor_cname:''
            }
        },
        mounted: function(){
            this.$parent.$parent.show_subview = true;
            var para = this.$base.getRequest();
            this.vendor_id = para.vendor_id || '';
            this.vendor_cname = para.vendor_cname || '';
        },
        methods:{
            cancel: function(){
                this.$base.linkBack();
            },
        },
        beforeDestroy: function () {
            this.$parent.$parent.show_subview = false;
            this.$parent.$parent.relist = this.relist;
        }
    }

</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/vendor/code/crsn.vue